import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ContactService } from 'app/core/contact/contact.service';
import { FacebookService } from 'app/core/digital-marketing/facebook.service';

@Injectable({
    providedIn: 'root'
})
export class FBCampaignPerformanceDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(private _fbService: FacebookService, private router: Router, private user: ContactService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        let isAdmin = localStorage.getItem('account_type')?.includes('admin')
        let performance = this._fbService.getCampaignPerformancesInitial()
        let users = this.user.getContacts('user', null, 100, null, null, null, null)

        let sources = [performance]
        if (isAdmin)
            sources.push(users)
            
        return forkJoin(sources)
    }

}